// extracted by mini-css-extract-plugin
export default {"created":"Modal_created__N9nJl","title":"Modal_title__hoE23","modalDialog":"Modal_modalDialog__UJb7O","modalFooter":"Modal_modalFooter__i1ljn"};